// extracted by mini-css-extract-plugin
export default {"wrapper":"ShopifySelectRetailer_wrapper__80Fwi","selectWrapper":"ShopifySelectRetailer_selectWrapper__KTIe3"};